import React from 'react'
import {remCalc} from '../../../theme/_utils'
import {
    Text,
    Flex,
    Box,
    useMultiStyleConfig,
    useStyleConfig,
    useMediaQuery,
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ChevronDown} from '../../icons'
import PropTypes from 'prop-types'
import RecipeStep from './recipe-step'
import {FormattedMessage} from 'react-intl'

const RecipeStepsMenu = ({recipeSteps}) => {
    const styles = useMultiStyleConfig('RecipeDetails', {})
    const {stepsMenu} = styles || {}
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(767.9)})`)
    const accordionStyles = useStyleConfig('Accordion')
    const content = !isMobile ? (
        recipeSteps?.length > 0 ? (
            <Box {...stepsMenu?.stepsContainer}>
                <Box {...stepsMenu?.innerContainer}>
                    <Text as="h2" {...stepsMenu?.stepsTitle}>
                        <FormattedMessage
                            id="recipes.details_page.steps.title"
                            defaultMessage="Instructions"
                        />
                    </Text>
                    <Flex flexDir="column">
                        {recipeSteps &&
                            recipeSteps?.map((step, idx) => {
                                return (
                                    <RecipeStep
                                        key={idx}
                                        step={step}
                                        totalSteps={recipeSteps?.length}
                                    />
                                )
                            })}
                    </Flex>
                </Box>
            </Box>
        ) : (
            <></>
        )
    ) : (
        <Flex {...accordionStyles?.accordionContainer}>
            <Accordion w="100%" allowToggle>
                <AccordionItem {...accordionStyles?.item} paddingX="0">
                    <Flex w="100%" justifyContent="space-between">
                        <AccordionButton {...accordionStyles?.button}>
                            <Box
                                flex="1"
                                textAlign="left"
                                textStyle="head-medium"
                                fontWeight="semibold"
                            >
                                <FormattedMessage
                                    id="recipes.details_page.steps.how_to"
                                    defaultMessage="How To"
                                />
                            </Box>
                            <ChevronDown />
                        </AccordionButton>
                    </Flex>

                    <AccordionPanel {...accordionStyles?.panel}>
                        {recipeSteps &&
                            recipeSteps?.map((step, idx) => {
                                return (
                                    <RecipeStep
                                        key={idx}
                                        step={step}
                                        totalSteps={recipeSteps?.length}
                                    />
                                )
                            })}
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </Flex>
    )

    return content
}

RecipeStepsMenu.propTypes = {
    recipeSteps: PropTypes.array,
}
export default RecipeStepsMenu
